// extracted by mini-css-extract-plugin
export default {"root":"ValidationError_root__LVczR h4","icon":"ValidationError_icon__nKa0T"};